<template>
  <div class="h-full">
    <div
      class="card-chart relative h-full w-full"
      v-for="(c, index) in charts"
      :key="index"
    >
      <v-chart
        v-if="c.active && c.label == 'Linha'"
        autoresize
        :option="chartLine(investment_data.tr_history)"
        class="w-full"
      >
      </v-chart>
      <v-chart
        v-if="c.active && c.label == 'Barra'"
        autoresize
        :option="chartBar(investment_data)"
        class="w-full"
      ></v-chart>
      <!-- <v-chart
        v-if="c.active && c.label == 'Heatmap'"
        autoresize
        :options="chartHeatmap(investment_data)"
      ></v-chart> -->
    </div>
    <nav class="flex space-x-4 pb-0 sm:pb-6" aria-label="Tabs">
      <a
        v-for="(c, index) in charts"
        :key="index"
        href="#"
        :class="
          c.active
            ? 'border-b-2 border-ontick-blue-500 text-ontick-steel-900 dark:text-gray-300'
            : ''
        "
        class="px-2 py-1 text-sm font-medium text-gray-400 hover:text-gray-700"
        @click="activeCharts(c)"
      >
        {{ c.label }}
      </a>
    </nav>
  </div>
</template>

<script>
import VChart from "vue-echarts";
import { use, graphic } from "echarts/core";
import { CanvasRenderer, SVGRenderer } from "echarts/renderers";
import { LineChart, BarChart } from "echarts/charts";
import {
  GridComponent,
  DatasetComponent,
  DataZoomComponent,
  BrushComponent,
} from "echarts/components";
import formatDate from "@/app/shared/utils/date.js";
import moment from "moment";
import { mapState } from "vuex";

use([
  CanvasRenderer,
  SVGRenderer,
  LineChart,
  BarChart,
  GridComponent,
  DatasetComponent,
  DataZoomComponent,
  BrushComponent,
]);

export default {
  name: "detailsChart",

  components: {
    VChart,
  },

  props: {
    charts: { type: Array, default: [] },
    investment_data: { type: Object, default: null },
  },

  data() {
    return { height: 0 };
  },

  watch: {
    investment_data: {
      deep: true,
      handler(value) {
        return value;
      },
    },

    "$screen.height": {
      immediate: true,
      handler(current) {
        this.height = current;
      },
      // this.addResizeEvent("Height", current, old);
    },
  },

  computed: {
    ...mapState({
      config: (state) => state.config,
    }),
  },

  methods: {
    activeCharts(value) {
      this.charts.forEach((item) => {
        item.active = false;
      });
      value.active = true;
    },

    InsertZeros(sourceArray, datesArray) {
      if (sourceArray.length > 1) {
        for (var i = 0; i < sourceArray.length; i++) {
          if (sourceArray[i] < 0 && sourceArray[i + 1] > 0) {
            sourceArray.splice(i + 1, 0, 0);
            datesArray.splice(i + 1, 0, datesArray[i]);
          } else if (sourceArray[i] > 0 && sourceArray[i + 1] < 0) {
            sourceArray.splice(i + 1, 0, 0);
            datesArray.splice(i + 1, 0, datesArray[i]);
          }
        }
      }
      return [sourceArray, datesArray];
    },
    GetPositiveData(sourceArray) {
      let data_copy = sourceArray;
      for (var i = 0; i < data_copy.length; i++) {
        if (data_copy[i] < 0) {
          data_copy[i] = null;
        }
      }
      return data_copy;
    },
    //
    GetNegativeData(sourceArray) {
      let data_copy = sourceArray;
      for (var i = 0; i < data_copy.length; i++) {
        if (data_copy[i] > 0) {
          data_copy[i] = null;
        }
      }
      return data_copy;
    },

    chartLine(value) {
      let list_date = [];
      let values = [];
      let grid;

      let dark =
        this.config.ui_theme == "DARK"
          ? this.config.theme_chart.dark
          : this.config.theme_chart.light;
      //
      // let value_up = JSON.parse(JSON.stringify(value));
      // let value_dn = JSON.parse(JSON.stringify(value));

      value.forEach((item) => {
        list_date.push(item.datetime);
        values.push(item.result);
      });

      let value_date = JSON.parse(
        JSON.stringify(this.InsertZeros(values, list_date)[1])
      );
      let value_up = JSON.parse(
        JSON.stringify(this.InsertZeros(values, list_date)[0])
      );
      let value_dn = JSON.parse(
        JSON.stringify(this.InsertZeros(values, list_date)[0])
      );
      let pos_data = this.GetPositiveData(value_up);
      let neg_data = this.GetNegativeData(value_dn);

      if (this.$screen.portrait) {
        grid = {
          left: "12%",
          right: "0%",
          bottom: "10%",
          top: "10%",
        };
      } else {
        grid = {
          left: "3%",
          right: "0%",
          bottom: "10%",
          top: "10%",
        };
      }

      let option = {
        dataZoom: [{ type: "inside", filterMode: "filter", minSpan: 40 }],

        grid: grid,

        legend: {
          show: false,
        },
        toolbox: {
          show: false,
        },
        tooltip: {
          show: false,
        },
        xAxis: [
          {
            data: value_date,
            type: "category",
            boundaryGap: false,

            axisLine: {
              lineStyle: { color: dark.line },
            },

            axisLabel: {
              formatter: function (value) {
                let new_date = "";
                new_date = moment(value).format("L");
                return new_date;
              },
              color: dark.font_color,
              fontSize: 10,
              fontFamily: "Poppins",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: {
          type: "value",
          scale: true,

          nameTextStyle: {
            fontSize: 10,
            show: false,
          },
          axisLabel: {
            color: dark.font_color,
            fontSize: 10,
            fontFamily: "Poppins",
            formatter: function (value) {
              value = value.toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
              });
              return value;
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: dark.line,
            },
            show: true,
          },
          minorSplitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "Negative",
            type: "line",
            symbol: "circle",
            symbolSize: 0,
            // sampling: "average",
            data: neg_data,

            itemStyle: {
              color: "#e74c3c",
            },

            areaStyle: {
              color: new graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(235, 77, 75, 0.5)",
                },
                {
                  offset: 1,
                  color: dark.chart_2,
                },
              ]),
            },
            animationDelay: function (idx) {
              return idx * 2000;
            },
          },

          {
            name: "Positive",
            type: "line",
            symbol: "circle",
            symbolSize: 0,
            data: pos_data,

            itemStyle: {
              color: "#19D684",
            },

            areaStyle: {
              color: new graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(25, 214, 132, 0.5)",
                },
                {
                  offset: 1,
                  color: dark.chart_2,
                },
              ]),
            },
            animationDelay: function (idx) {
              return idx * 2000;
            },
          },
        ],
        animationEasing: "elasticOut",
        animationDelayUpdate: function (idx) {
          return idx * 5;
        },
      };

      return option;
    },

    chartBar(value) {
      let array_tr_history = [];
      let dark =
        this.config.ui_theme == "DARK"
          ? this.config.theme_chart.dark
          : this.config.theme_chart.light;

      value.tr_history.forEach((item) => {
        array_tr_history.push(item);
      });

      let grid;

      if (this.$screen.portrait) {
        grid = {
          left: "6%",
          right: "0%",
          bottom: "10%",
          top: "10%",
        };
      } else {
        grid = {
          left: "3%",
          right: "0%",
          bottom: "10%",
          top: "10%",
        };
      }

      let option = {
        dataset: {
          dimensions: ["datetime", "diff"],

          source: array_tr_history,
        },
        dataZoom: [
          {
            show: false,
            start: 0,
            end: 100,
          },
          {
            type: "inside",
            start: 0,
            end: 100,
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: "empty",
            width: 12,
            height: "50%",
            showDataShadow: false,
            left: "99%",
          },
        ],

        tooltip: {
          trigger: "item",

          formatter: function (params) {
            let textTooltip;
            let date;
            date = formatDate(params.data.datetime);

            textTooltip = `${params.marker} ${params.data.diff} <br/> ${date}`;
            return textTooltip;
          },
        },

        brush: {
          toolbox: ["lineX", "clear"],

          throttleType: "debounce",
          throttleDelay: 500,
          // seriesIndex: "all",

          xAxisIndex: [0, 1],
          yAxisIndex: [0, 1],

          // brushLink: "all",
        },
        grid: grid,

        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            axisLabel: {
              formatter: function (value) {
                let new_date = "";
                new_date = formatDate(value);
                return new_date;
              },
              color: dark.font_color,
              fontSize: 10,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: {
          type: "value",
          scale: true,

          nameTextStyle: {
            show: false,
          },
          axisLabel: {
            color: dark.font_color,
            fontSize: 10,
            formatter: function (value) {
              value = value.toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
              });
              return value;
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: dark.line,
            },
            show: true,
          },
          minorSplitLine: {
            show: false,
          },
        },
        series: [
          {
            encode: {
              y: "diff",
              x: "datetime",
            },

            dimensions: ["datetime", "diff"],
            type: "bar",
            symbol: "circle",
            symbolSize: 0,
            sampling: "average",
            itemStyle: {
              normal: {
                color: function (params) {
                  let color_selected;
                  let rgba = { g: 0, r: 0, b: 0, y: 0 };

                  if (params.data.diff > 0) {
                    color_selected = "rgba(25, 214, 132, 0.8)";
                    rgba.g = 0;
                    rgba.r = 0;
                    rgba.b = 0;
                    rgba.y = 1;
                  } else {
                    color_selected = "rgba(235, 77, 75, 0.8)";
                    rgba.g = 0;
                    rgba.r = 1;
                    rgba.b = 0;
                    rgba.y = 0;
                  }
                  return new graphic.LinearGradient(
                    rgba.g,
                    rgba.r,
                    rgba.b,
                    rgba.y,
                    [
                      { offset: 0.1, color: color_selected },
                      { offset: 1, color: "rgba(32, 42, 55, 0.8)" },
                    ]
                  );
                },
              },
            },
          },
        ],
      };

      return option;
    },

    chartHeatmap(value) {
      let heatmap_data = [];

      value.forEach((item) => {
        heatmap_data.push(item.heatmap);
      });

      let option = {
        grid: {
          height: "100%",
          top: "0%",
        },

        animation: true,

        tooltip: {},
        visualMap: {
          type: "piecewise",
          max: 200,
          min: -200,

          left: "center",

          calculable: true,
          realtime: true,
          splitNumber: 10,
          orient: "horizontal",
          inverse: true,

          textStyle: {
            color: "#fff",
          },
          inRange: {
            color: [
              "#EF4444",
              "#F87171",
              "#FCA5A5",
              "#FECACA",
              "#FEE2E2",
              "#ffffff",
              "#D1FAE5",
              "#A7F3D0",
              "#6EE7B7",
              "#34D399",
              "#10B981",
            ],
          },
        },
        calendar: {
          top: 30,
          left: 30,
          right: 30,
          bottom: 30,
          cellSize: ["auto", "auto"],
          range: ["2020", "2021", "2022"],
          splitLine: {
            show: false,
          },
          textStyle: {
            color: "#fff",
          },
          itemStyle: {
            borderWidth: 0.5,
            borderColor: "#171e27",
            color: "#202a37",
          },
          yearLabel: { show: false },
          dayLabel: {
            show: true,
            color: "#fff",
            nameMap: ["D", "S", "T", "Q", "Q", "S", "S"],
          },

          monthLabel: {
            color: "#fff",
            nameMap: [
              "Jan",
              "Fev",
              "Mar",
              "Abr",
              "Mai",
              "Jun",
              "Jul",
              "Ago",
              "Set",
              "Out",
              "Nov",
              "Dez",
            ],
          },
        },
        series: {
          type: "heatmap",
          coordinateSystem: "calendar",
          data: heatmap_data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      };
      return option;
    },
  },
};
</script>

<style>
@media (max-width: 780px) {
  .card-chart .echarts {
    width: 100%;
    height: 240px;
  }
}
/*
@media screen and (min-height: 667px) and (max-height: 770px) {
  .card-chart .echarts {
    width: 100%;
    height: 330px;
  }
}

@media screen and (min-height: 770px) and (max-height: 900px) {
  .card-chart .echarts {
    width: 100%;
    height: 380px;
  }
}

@media screen and (min-height: 900px) and (max-height: 1050px) {
  .card-chart .echarts {
    width: 100%;
    height: 500px;
  }
} */
</style>
